import styled from 'styled-components'
import React, { useContext } from 'react'
import { Modal, paddingModalStyles } from '@futures-platform/ui'
// import { InfoCircle } from '@styled-icons/boxicons-regular'
import { PUBLIC_URL } from '../../env'
import { DataContext } from '../../store/GlobalState'

const WarningEditModal = ({
  InfoModalHeader,
  InfoModalDescription1,
  InfoModalDescription2,
  InfoModalDescription3,
  InfoModalDescription4,
  InfoModalNote,
  InfoModalOpen,
  InfoModalClose,
  InfoModalHandle,
  LearnMoreLink,
  GuideLink,
  LearnMoreBtn,
  GuideBtn,
  gid,
  openingFieldEditingModalHandler,
  InfoModalDescription5,
  InfoModalDescription5Sub1,
  InfoModalDescription5Sub2,
  InfoModalDescription5Sub3,
  NameOKBtn,
}) => {
  const {
    state: { scenarioSet },
    dispatch,
  } = useContext(DataContext)

  const openScenarioSetHandler = () => {
    window.location.replace(
      `${PUBLIC_URL}/scenario?gid=${gid}&scenario-set-id=${scenarioSet?.id}`,
    )
  }
  const createNewScenarioSetHandler = () => {
    window.location.href = `${PUBLIC_URL}/scenario?gid=${gid}`
  }

  return (
    <Modal
      onRequestClose={InfoModalClose}
      isOpen={InfoModalOpen}
      contentLabel="radar-modal"
      ariaHideApp={false}
      style={paddingModalStyles}>
      <div
        className="confirmation-modal-content "
        style={{
          padding: '32px',
        }}>
        <div
          className="modal-form-section modal-form-header"
          style={{ padding: 0 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              // alignItems: "center",
            }}>
            <h4
              style={{
                marginBottom: '0',
                fontWeight: 600,
                fontSize: '26px',
              }}>
              {InfoModalHeader}
            </h4>
          </div>
          <div
            className="mt-4"
            style={{
              display: 'block !important',
              // fontWeight: 500,
            }}>
            <p
              style={{
                color: 'red',
                marginRight: '2px',
                display: 'inline',
                fontSize: '14px',
                // fontWeight: 500,
              }}>
              {InfoModalDescription1}
            </p>
            {InfoModalDescription3}
            {!!InfoModalDescription2 && (
              <p
                style={{
                  // marginBottom: '3rem',
                  marginTop: '1rem',
                  fontSize: '14px',
                  // fontWeight: 500,
                }}>
                {InfoModalDescription2}
              </p>
            )}
          </div>
          {/* <p
            style={{
              marginTop: "16px",
              fontWeight: 400,
            }}
          >
          
            
          </p> */}
          {!!InfoModalDescription5 && (
            <InformationUl
              style={{
                // marginLeft: '65px',
                marginTop: '1rem',
                marginBottom: '3rem',
                padding: 0,
                fontSize: '14px',
                // fontWeight: 700,
                fontFamily: 'L10',
              }}>
              {InfoModalDescription5}
              <div style={{ marginLeft: '11.5px' }}>
                {InfoModalDescription5Sub1 && (
                  <InformationLi>{InfoModalDescription5Sub1}</InformationLi>
                )}
                {InfoModalDescription5Sub2 && (
                  <InformationLi>{InfoModalDescription5Sub2}</InformationLi>
                )}
                {InfoModalDescription5Sub3 && (
                  <InformationLi>{InfoModalDescription5Sub3}</InformationLi>
                )}
              </div>
            </InformationUl>
          )}
          {!!InfoModalDescription4 && (
            <p
              style={{
                marginTop: '24px',
                fontSize: '14px',
                fontWeight: 500,
              }}>
              {InfoModalDescription4}
            </p>
          )}
          <div
            style={{
              // marginBottom: '31px',
              marginTop: '31px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}>
            <div>
              <button
                style={{ color: 'gray', border: 'none', fontSize: '18px' }}
                className="btn btn-lg btn-outline-secondary"
                onClick={InfoModalClose}>
                {'CANCEL'}
              </button>
              <button
                className="btn btn-lg btn-primary"
                style={{ marginLeft: '16px' }}
                // onClick={InfoModalHandle}
                disabled={!scenarioSet?.id}
                onClick={
                  scenarioSet?.id ? openingFieldEditingModalHandler : null
                }>
                {NameOKBtn || 'OK'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default WarningEditModal

// const InformationIcon = styled(InfoCircle)`
//   background-color: white;
//   color: #00c3ff;
//   width: 45px;
//   height: 45px;
// `
const InformationUl = styled.ul`
  line-height: 2;
`
const InformationLi = styled.li`
  line-height: 1.4
  margin-top: 4px;
  margin-bottom: 4px;
`

// const InformationLink = styled.p`
//   color: #006998;
//   &:hover {
//     cursor: pointer;
//   }
// `
